import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { Modal } from "react-bootstrap";
import { notify } from "../../utils/toast";

export const Vehicle = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getData = async () => {
    try {
      setLoader(true);
      const response = await api.getVehicle();
      console.log(response);
      if (response?.success) {
        setData(response?.vehicles || []);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const delteVehicle = async (id) => {
    if (!window.confirm("Are you sure you want to delete this vehicle?")) return;
    try {
      const response = await api.deleteVehicle(id);
      console.log(response);
      if (response?.success) {
        notify.success("Vehicle deleted successfully!");
        getData();
      }
    } catch (error) {
      console.log(error);

      notify.error("Something went wrong!");
    }
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <h3>Vehicles</h3>
            <Table data={data} delteVehicle={delteVehicle} />
          </div>
        </div>
        <div className="AddEmpBtn" onClick={handleShow}>
          <i className="fa-solid fa-plus"></i>
        </div>
      </div>
      <CreateVehicleModal
        show={show}
        handleClose={handleClose}
        getVehicle={getData}
      />
      {/* /.container-fluid */}
    </>
  );
};

const NumberPlate = ({ number }) => (
  <div style={{
    display: "inline-block",
    background: "#fff",
    border: "2.5px solid #222",
    borderRadius: 6,
    overflow: "hidden",
    minWidth: 120,
    boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
  }}>
    <div style={{
      background: "repeating-linear-gradient(90deg, #c0392b 0px, #c0392b 10px, #e74c3c 10px, #e74c3c 14px, #c0392b 14px, #c0392b 24px)",
      height: 8,
      width: "100%",
    }} />
    <div style={{
      padding: "4px 10px 2px",
      textAlign: "center",
      fontWeight: 900,
      fontSize: 15,
      letterSpacing: 3,
      color: "#111",
      fontFamily: "'Courier New', monospace",
      textTransform: "uppercase",
    }}>
      {number || "—"}
    </div>
    <div style={{
      textAlign: "center",
      fontSize: 8,
      fontWeight: 700,
      letterSpacing: 4,
      color: "#444",
      paddingBottom: 4,
      textTransform: "uppercase",
    }}>
      SINDH
    </div>
  </div>
);

const Table = ({ data, delteVehicle }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col" className="">
                  Number Plate
                </th>
                <th scope="col" className="">
                  Type
                </th>
                <th scope="col" className="">
                  model
                </th>
                <th scope="col" className="">
                  Capacity
                </th>
                <th scope="col" className="">
                  Fuel Type
                </th>
                <th scope="col" className="">
                  Assigned Driver
                </th>
                <th scope="col" className="">
                  Status
                </th>
                <th scope="col" className=""></th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    <NumberPlate number={item?.numberPlate} />
                  </td>
                  <td scope="row">
                    <div className="table-text-dark" style={{textTransform:"capitalize"}}>{item?.type}</div>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db" style={{textTransform:"capitalize"}}>{item?.model}</span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">{item?.capacity}</span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db" style={{textTransform:"capitalize"}}>{item?.fuelType}</span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">{item?.assignedDriver?.name}</span>
                  </td>
                  <td>
                    <span style={{
                      display: "inline-block",
                      padding: "3px 10px",
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: 600,
                      textTransform: "capitalize",
                      background: item?.status === "active" ? "#d1fae5" : "#fee2e2",
                      color: item?.status === "active" ? "#065f46" : "#991b1b",
                    }}>
                      {item?.status}
                    </span>
                  </td>
                  <td>
                    <div
                      className="delete p-2 ms-1 cursor-pointer"
                      onClick={() => delteVehicle(item?._id)}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const CreateVehicleModal = ({ show, handleClose, getVehicle }) => {
  const [drivers, setDrivers] = useState([]);
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);

  const handleSubmit = async () => {
    try {
      console.log(data);
      let payload = {
        numberPlate: data?.numberPlate,
        type: data?.type,
        model: data?.model,
        capacity: data?.capacity,
        fuelType: data?.fuelType,
        assignedDriver: data?.assignedDriver,
      };
      console.log(payload);

      const response = await api.addVehicle(payload);
      console.log(response);
      if (response?.success) {
        getVehicle();
        notify.success("Vehicle successfully added!");
        setData({});
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const getData = async () => {
    try {
      setLoader(true);
      const response = await api.getDrivers();
      console.log(response);
      if (response?.success) {
        setDrivers(response?.drivers || []);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}>
          <i className="fa-solid fa-xmark" />
        </div>
        <div className="h3">Add Vehicle</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Number Plate</label>
              <input
                type="text"
                name="numberPlate"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <label>Type</label>
              <select
                name="type"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              >
                <option value="">Select</option>
                <option value="car">Car</option>
                <option value="van">Van</option>
                <option value="bus">Bus</option>
              </select>
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label>Model</label>
              <input
                type="text"
                name="model"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label>Capacity</label>
              <input
                type="number"
                name="capacity"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label>Fuel Type</label>
              <select
                name="fuelType"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              >
                <option value="">Select</option>
                <option value="petrol">Petrol</option>
                <option value="diesel">Diesel</option>
                <option value="cng">Cng</option>
              </select>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Assigned Driver</label>
              <select
                name="assignedDriver"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              >
                <option value="">Select</option>
                {drivers.map((item, key) => (
                  <option value={item?._id} key={key}>
                    {item?.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="mt-4 ">
          <button className="themeBtn w-100 text-center" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
};
